/* eslint-disable*/
import * as React from 'react';

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    useTheme,
} from '@mui/material';
import { ESstrings } from '../../localisation/strings.en';
import { DialogProps } from './interfaces';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ResponsiveDialog: React.FC<DialogProps> = ({
    isOkEnable,
    open,
    title,
    message,
    showOk,
    imagePath,
    okBtnName,
    cancelBtnName,
    ContentNode,
    onClose,
    showCloseIcon = false,
}: DialogProps): JSX.Element => {
    const theme = useTheme();
    const handleClose = (result: boolean): void => {
        onClose(result);
    };

    const styles = {
        noButtonUI: { width: '20%', margin: theme.spacing(2) },
        yesButtonUI: { width: '20%' },
        DividerStyle: { justifyContent: 'center', widows: '50%' },
        closeIcon: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
    };

    return (
        <Dialog
            data-testid="responsive-dialog"
            open={open ?? false}
            disableEnforceFocus
            fullWidth
        >
            <DialogTitle id="responsive-dialog-title">
                <div style={styles.closeIcon}>
                    <div>{title}</div>
                    {showCloseIcon && (
                        <IconButton data-testid="dialog-close-btn" component="button" onClick={() => handleClose(false)}>
                            <CloseIcon />
                        </IconButton>
                    )}
                </div>
            </DialogTitle>
            <DialogContent dividers style={styles.DividerStyle}>
                <div
                    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}
                >
                    {imagePath !== '' && (
                        <>
                            <br />
                        </>
                    )}
                    {/* here is the check to fetch html string from the latest.txt and display using dangerouslySetInnerHTML */}
                    {title === ESstrings.SessionTimeout ? (
                        ContentNode
                    ) : title === 'RELEASE NOTES' ? (
                        <div dangerouslySetInnerHTML={{ __html: message }} />
                    ) : (
                        <DialogContentText>{message}</DialogContentText>
                    )}
                </div>
            </DialogContent>
            <DialogActions>
                <Button
                    data-testid="dialog-ok-btn"
                    disabled={isOkEnable}
                    variant="outlined"
                    color="primary"
                    style={styles.yesButtonUI}
                    onClick={() => handleClose(true)}
                >
                    {okBtnName ? okBtnName : ESstrings.OK}
                </Button>

                {showOk && (
                    <Button
                        data-testid="dialog-cancel-btn"
                        variant="outlined"
                        color="primary"
                        style={styles.noButtonUI}
                        onClick={() => handleClose(false)}
                    >
                        {cancelBtnName ? cancelBtnName : ESstrings.Cancel}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ResponsiveDialog;
